/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute(_this) {
  var loadingImage;
  pInfScrNode = $(_this).closest('.collection-view-more-button_wrapper').last();	
  pInfScrURL = $(_this).last().attr("next_url");
  if(!pInfScrLoading && pInfScrNode.length > 0) {
    console.log(pInfScrURL)
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        pInfScrLoading = true;
        // loadingImage = pInfScrNode.clone().empty().append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
        // loadingImage.insertAfter(pInfScrNode);
        // pInfScrNode.hide();
      },
      success: function(data) {
        // remove loading feedback
          // console.log(data);
          // $('.collection-view-more-button').last().remove();
          // loadingImage.remove();
          // $('.collection__results-product-list-loading').remove();
        
          var filteredData = $(data).find(".product-list__inner");
          console.log('filteredData.length',filteredData.html());
          $(_this).closest('.product-facet__main').find('.product-list__inner').append(filteredData.html());
          $(_this).closest('.featured-collections').find('.product-list__inner').append(filteredData.html());
          $(_this).closest('.collection-view-more-button_wrapper').html($(data).find('.collection-view-more-button_wrapper').html());
          $(this).attr("aria-busy","false");
          pInfScrLoading = false;
      },
      dataType: "html"
    });
  }
}
$(document).ready(function() {
  $('body').on('click', '.collection-view-more-button', function(e) {
     e.preventDefault();
     $(this).attr("aria-busy","true");
     pInfScrExecute(this);
  });
  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }

  if($('#timermain').length > 0){
    var endtime = $('#timermain').attr('data-timer');
    // Set the date we're counting down to
    var countDownDate = new Date(endtime).getTime();
    
    // Update the count down every 1 second
    var x = setInterval(function() {
    
      // Get today's date and time
      var now = new Date().getTime();
        
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
        
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));   
      if(days < 10){
        days = '0'+days; 
      } 
      var dayshtml = '';
      if(days > 0){
        dayshtml = '<span class="value">'+days+'</span><span> : </span>';
      }      
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));      
      if(hours < 10){
        hours = '0'+hours; 
      } 
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if(minutes < 10){
        minutes = '0'+minutes; 
      } 
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if(seconds < 10){
        seconds = '0'+seconds; 
      } 
        
      // Output the result in an element with id="demo"
      document.getElementById("timermain").innerHTML = dayshtml+'<span class="value">'+hours+'</span><span> : </span><span class="value">'+minutes+'</span><span> : </span><span class="value">'+seconds+'</span>';
        
      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("timermain").innerHTML = "Expired";
        $('#timermain').closest('announcement-bar-item').remove();
      }
    }, 1000);
  }

  $('.rm-content-text').click(function(e) {
    e.preventDefault();
    $('.rm-content_wrapper').toggleClass('active');
    if ($('.rm-content-text').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
  
  // if($('body').hasClass('template-collection')){
  //   if ($("product-facet product-list product-item:hidden").length == 0) {
  //       $(".collection-view-more-button").css('display', 'none');
  //   }
  //   $("body").on('click touchstart', '.collection-view-more-button .view-more', function (e) {
  //       e.preventDefault();
  //       var itemshow = $('.product-list__inner').attr('data-itemshow');
  //       $("product-item:hidden").slice(0, itemshow).slideDown();
  //       if ($("product-item:hidden").length == 0) {
  //           $(".collection-view-more-button").css('display', 'none');
  //       }
  //   });	 
  // }   

  $('body').on('click','.product-form__option-selector[data-selector-type="color"] input[type="radio"]', function(){
    if($('.product__media-nav .product__thumbnail-list .product__thumbnail-item[data-alttext="'+$(this).val()+'"]').length > 0){
      $('.product__media-nav .product__thumbnail-list .product__thumbnail-item[data-alttext="'+$(this).val()+'"]').trigger('click');
    }    
  });
  
    $('body').on('change','.has_size [data-selector-type="block"] .block-swatch__radio', function(){
      var closest = $(this).closest('.has_size');
      if(closest.find('[data-selector-type="block"] .block-swatch__radio:checked').closest('.block-swatch').hasClass('is-disabled') == false){
       closest.find('[data-product-add-to-cart-button] .loader-button__text').html(document.querySelector("[data-product-add-to-cart-button]").getAttribute("data-button-content")); 
      }      
      closest.find('[data-product-add-to-cart-button]').removeAttr('disabled');
    });

  var oldhtml = '';
  $('body').on('change','.size-guid-wrapper [name="in_cm"]', function(){
    var sel_val = $('.size-guid-wrapper [name="in_cm"]:checked').val();    
    if(sel_val == 'in'){      
      $('.size-guid-wrapper .size-chart-table-wrapper').html(oldhtml);
    }else{
      oldhtml = $('.size-guid-wrapper .size-chart-table-wrapper').html();
      $('.waist_label').text('To Fit Waist(cm)');
      $('.lengh_label').text('Inseam Length(cm)');
      $(".size-guid-wrapper .size-chart-table .size_value").each(function(){
        $(this).html(parseFloat($(this).html()) * 2.54);
      }); 
    }
  }); 
  
   $(".shop_more-row").slick({
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    }); 
  $(".new-arrivals-row").slick({
      arrows: true,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  $(".yml-row").slick({
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  
    $('.reviews-block').slick({
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.logo_part-all-imgs-wrapper',
      arrows: false,
    });
    $('.logo_part-all-imgs-wrapper').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      asNavFor: '.reviews-block',
      dots: false,
      focusOnSelect: true
    });

  $('.banner-slider-enabled').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite:true,
    dots:true,
    arrows:true,
    autoplay: true,
    autoplaySpeed: 5000
  });
  
  $('.size_guid-tab-link').click(function(e){
      e.preventDefault();
      var tab_id = $(this).attr('href');

      $('.size_guid-tab-link').removeClass('active');
      $('.size_guid-tabs-content').removeClass('active');

      $(this).addClass('active');
      $(tab_id).addClass('active');
  })
  // if (window.matchMedia('(min-width: 740px)').matches){
  //   $('.product-tab-content:first-child').addClass('active')
  // }
  $('body').on('click','.product-description-tabs .product-tabs-head', function(){
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $('.product-description-tabs .product-tabs-content-wrapper .product-tab-content[data-tab="'+$(this).attr('data-tab')+'"]').removeClass('active'); 
    }else{
      $('.product-description-tabs .product-tabs-head').removeClass('active');
      $('.product-description-tabs .product-tabs-content-wrapper .product-tab-content').removeClass('active');
      $(this).addClass('active');
      $('.product-description-tabs .product-tabs-content-wrapper .product-tab-content[data-tab="'+$(this).attr('data-tab')+'"]').addClass('active'); 
    }
  });
  
  $('body').on('click','.product-description-tabs .product-tab-content .product-tabs-head-title', function(){    
    if($(this).closest('.product-tab-content').hasClass('active')){      
      $(this).closest('.product-tab-content').removeClass('active');     
    }else{
      $('.product-description-tabs .product-tab-content').removeClass('active');
      $(this).closest('.product-tab-content').addClass('active');     
    }    
  });

  $('a[href^="#"]').on('click',function (e) {
    var target = this.hash,
        $target = $(target);
  
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top-280
    }, 900, 'swing', function () {
      window.location.hash = target;
    });
  });

  // $('body').on('click','.product-form__payment-container.sticky-atc .scrollablebutton', function(){
  //   console.log('00');
  //   $('html, body').animate({
  //     'scrollTop': $('.product-form.has_size product-variants').offset().top - 100
  //   }, 900, function(){
  //     $('product-variants [data-selector-type="block"] .block-swatch-list').addClass('shake');
  //     setTimeout(function(){
  //       $('product-variants [data-selector-type="block"] .block-swatch-list').removeClass('shake');
  //     },1000)
  //   });
  // });
  $('#AddToCart .loader-button__text').click(function(){
    if($(this).html().includes('size') == true){  
      if (window.matchMedia('(max-width: 740px)').matches){
        $('html, body').animate({
          'scrollTop': $('.product-form.has_size product-variants').offset().top - 100
        }, 900);
      }
      console.log('00',$('#AddToCart .loader-button__text').html().includes('size'));
      $('product-variants [data-selector-type="block"] .block-swatch-list').addClass('shake');
      setTimeout(function(){
        $('product-variants [data-selector-type="block"] .block-swatch-list').removeClass('shake');
      },1000)
    }
  });
  
  // if($('.template-product .product__info .product-form__payment-container').length > 0){
  //    $(window).on('resize scroll', function() {  
  //      if($(window).width() < 767){
  //       var elementTop = $('.template-product .product__info .product-form__buy-buttons').offset().top;
  //       var elementBottom = elementTop + $('.template-product .product__info .product-form__buy-buttons').outerHeight();
      
  //       var viewportTop = $(window).scrollTop();
  //       var viewportBottom = viewportTop + $(window).height();
            
  //       if (elementBottom > viewportTop) {
  //           $('.template-product .product__info .product-form__payment-container').removeClass('sticky-atc');
  //       } else {          
  //         $('.template-product .product__info .product-form__payment-container').addClass('sticky-atc');
  //       } 
  //      }         
  //     }); 
  //   }

  $('body').on('click','[data-summary_opanable]', function(){
    $('.payment-summary').slideToggle();
    $(this).toggleClass('open');
  });

  $('body').on('click','.size-chart-popup_toggle',function(){
     var selector = $(this).attr('aria-controls');
     $('#'+selector).fadeIn();
     $('html').addClass('lock-all');
  });
  $('body').on('click','.size-chart_popup_close',function(){
   $('.size-chart_popup').fadeOut();
   $('html').removeClass('lock-all');
  });

  $('.delivered_cst_text_iner').slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000
  });

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail.cart;

    var free_product = window.themeVariables.settings.free_product
    var freeProductThresholdSetting = window.themeVariables.settings.free_product_threshold
    var second_free_product = window.themeVariables.settings.second_free_product
    var secondFreeProductThresholdSetting = window.themeVariables.settings.second_free_product_threshold
    var no_free_gift_products = window.themeVariables.settings.no_free_gift_products
    // const {
    //   free_product,
    //   free_product_threshold: freeProductThresholdSetting,
    //   second_free_product,
    //   second_free_product_threshold: secondFreeProductThresholdSetting,
    //   no_free_gift_products: no_free_gift_products
    // } = window.themeVariables.settings;
  
    var freeProductThreshold = parseInt(freeProductThresholdSetting) * 100;
    var secondFreeProductThreshold = parseInt(secondFreeProductThresholdSetting) * 100;
  
    var freeProductAdded = false;
    var secondFreeProductAdded = false;

    var hasNoFreeGiftProduct = false;
    
    var NoFreeGiftProductIDs = new Set(no_free_gift_products.map(product => product.id));
    var hasNoFreeGiftProduct = cart.items.some(item => NoFreeGiftProductIDs.has(item.product_id));      
    console.log('hasNoFreeGiftProduct:', hasNoFreeGiftProduct);
  
    function refreshCart(){
      $.getJSON('/cart.js', function(cart){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart },
          })
        );
      });
    };
  
    const showModal = (selector, duration = 3000) => {
      const modal = $('#free_gift-modal_main');
      modal.fadeIn().addClass('active');
      setTimeout(() => {
        modal.fadeOut().removeClass('active');
      }, duration);
    };
  
    let carttotal = 0;
    let hasMini1 = false;
    let hasMini2 = false;

    // Determine if free products are already in the cart
    cart.items.forEach((item) => {
      if (item.product_id === free_product.id) {
        freeProductAdded = true;
      }
      if (item.product_id === second_free_product.id) {
        secondFreeProductAdded = true;
      }
      const hasFreeMini = item.properties && item.properties['_freemini'];
      if (!hasFreeMini) {
          carttotal += item.line_price; // line_price is already qty × unit_price
      }
      if (item.properties && item.properties['_mini_type'] === 'freemini1') {
        hasMini1 = true;
      }
      if (item.properties && item.properties['_mini_type'] === 'freemini2') {
        hasMini2 = true;
      }
    });


    function allremove(){
      var hasFirstFreeProductAdded = false;
      var hasSecondFreeProductAdded = false;
      
      var hasFirstFreeProductAdded = cart.items.some(function(item) {
        return item.product_id === window.themeVariables.settings.free_product.id;
      }); 
      
      var hasSecondFreeProductAdded = cart.items.some(function(item) {
        return item.product_id === window.themeVariables.settings.second_free_product.id;
      });

      var updateData = {};
      
      if(hasFirstFreeProductAdded){
        updateData[free_product.variants[0].id] = 0;
      }
      if(hasSecondFreeProductAdded){
        updateData[second_free_product.variants[0].id] = 0;
      }

      if (Object.keys(updateData).length > 0) {
          $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          async:true,
          success: function(data) {                
            console.log('sucess');
            refreshCart()
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
          }
        });
      }
    }
  
    // Logic to handle free product addition/removal
    if (hasNoFreeGiftProduct) {
      console.log('no_gift');
      if((free_product?.available) && (second_free_product?.available)){
        allremove();
      }
    } else {
      if((free_product?.available) && (second_free_product?.available)){
        if ((cart.total_price >= freeProductThreshold) && (cart.total_price < secondFreeProductThreshold)) {
          if (!freeProductAdded) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                id: free_product.variants[0].id,
                quantity: 1
              },
              dataType: 'json',
              async: true,
            }).done(function(){
              showModal();
              if (secondFreeProductAdded) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: { id: second_free_product.variants[0].id, quantity: 0 },
                  dataType: 'json',
                  async: true,
                }).done(refreshCart)
                  .fail((error) => {
                    console.error('Error removing free product:', error);
                  });
              }else{
                refreshCart();
              }
                
            }).fail((error) => {
              console.error('Error adding free product:', error);
            });
          }
          
        } else if (cart.total_price >= secondFreeProductThreshold) {

          if (!secondFreeProductAdded) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                id: second_free_product.variants[0].id,
                quantity: 1
              },
              dataType: 'json',
              async: true,
            }).done(function(){
              showModal();
              if (freeProductAdded) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: { id: free_product.variants[0].id, quantity: 0 },
                  dataType: 'json',
                  async: true,
                }).done(refreshCart)
                  .fail((error) => {
                    console.error('Error removing free product:', error);
                  });
              }else{
                refreshCart();
              }
                
            }).fail((error) => {
              console.error('Error adding free product:', error);
            });
          }
          
        }else{
          allremove();
        }
      } else if(free_product?.available){
        if ((cart.total_price >= freeProductThreshold)) {
          if (!freeProductAdded) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                id: free_product.variants[0].id,
                quantity: 1
              },
              dataType: 'json',
              async: false,
            }).done(refreshCart)
              .done(() => showModal())
              .fail((error) => {
                console.error('Error adding free product:', error);
              });
          }
        }else{
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { id: free_product.variants[0].id, quantity: 0 },
            dataType: 'json',
            async: false,
          }).done(refreshCart)
            .fail((error) => {
              console.error('Error removing free product:', error);
            });
        }
      }  
    }

    var freeminithreshold = parseInt(window.themeVariables.settings.free_mini_threshold);
    var freeminithreshold_2 = parseInt(window.themeVariables.settings.free_mini_threshold_2);

    
    let totalFormatted = (carttotal / 100).toFixed(2);
    if(totalFormatted > freeminithreshold_2 && hasMini1 && hasMini2){
      console.log('ifff')
      var updateData = {};
      cart.items.forEach(item => {
          // Check if the item has a property named "_freemini"
          const hasFreeMini = item.properties && item.properties['_freemini'] && item.properties['_mini_type'] == 'freemini1';
          if (hasFreeMini) {
            updateData[item.key] = 0;
          }
      });

      console.log(updateData)
      if (Object.keys(updateData).length != 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          success: function(data) {                
            refreshCart();
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
          }
        });
      }
    }else if(totalFormatted < freeminithreshold_2 && totalFormatted > freeminithreshold){
      console.log('elsssiffff1')
      var updateData = {};
      cart.items.forEach(item => {
          // Check if the item has a property named "_freemini"
          const hasFreeMini = item.properties && item.properties['_freemini'] && item.properties['_mini_type'] == 'freemini2';

          if (hasFreeMini) {
            updateData[item.key] = 0;
          }
      });

      console.log(updateData)
      if (Object.keys(updateData).length != 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          success: function(data) {                
            refreshCart();
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
          }
        });
      }
    }else if(totalFormatted < freeminithreshold){
      console.log('elsssiffff2222')
      var updateData = {};
      cart.items.forEach(item => {
        // Check if the item has a property named "_freemini"
        const hasFreeMini = item.properties && item.properties['_freemini'];

        if (hasFreeMini) {
            updateData[item.key] = 0;
        }
      });

      console.log(updateData)
      if (Object.keys(updateData).length != 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          success: function(data) {                
            refreshCart();
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
          }
        });
      }
    }
  });

  $('.free_gift-modal-close').click(function(e){
    e.preventDefault();
    $('#free_gift-modal_main').fadeOut();
    $('#free_gift-modal_main').removeClass('active');
  });

  $('body').on('click', '.line-item-property-input-submit', function(e) {
    e.preventDefault();
    var variant_id = parseInt($(this).attr('variant_id'))
    var input_value = $(this).parent('.line-item-property-input').find('input').val();

     var _this = $(this);
     _this.attr("disabled", "disabled");
     _this.attr("aria-busy", "true");
    _this.removeAttr("submit");
    
    $.ajax({
      url: "/cart/change.js",
      type: "POST",
      data: {
        id: variant_id, 
        quantity: 1, 
        properties:{ 
          _hasfreeitem: "yes",
          "Engraving Text": input_value 
        } 
      }, 
      contentType: "application/json",
      dataType: 'json'
    }).done(function (e) {
      _this.removeAttr("disabled");
      _this.removeAttr("aria-busy");
      $(_this).find('.loader-button__text').html('Edit');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         bubbles: true
       }));
    });
  });
  
  // var input_value = $('.line-item-property-input').find('input').val();
  $('body').on('click', '.product-item__cta_freemini', function(e) {
    e.preventDefault();
    $('.product-item__cta_freemini').attr('disabled','disabled');
    var variant_id = $(this).attr('data-vid');
    
    $(this).attr("aria-busy",true);
    var items = [];
    items.push({
      quantity: 1,
      id: variant_id,
      properties:{ 
        "_freemini": true,
        "_mini_type": $(this).attr('data-type')
      } 
    });   
    
    var data = {items};
    console.log('data',data)
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {     
      $.getJSON('/cart.js', function(cart){
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      // document.getElementById('mini-cart').open = true;
      $(this).removeAttr("aria-busy");
    }.bind(this));  

  });

  var pageaddedcnt = 0;

  function updateNavButtons(stepIndex) {
    stepIndex = parseInt(stepIndex);
    var totalSteps = $('.step_inner_main').length;
    // Show Prev and Next buttons initially
    $('.bundle-step-prev-next.prev').show();
    $('.bundle-step-prev-next.next').show();

    // Disable Prev on first step
    if (stepIndex === 1) $('.bundle-step-prev-next.prev').attr('disabled', true);
    else $('.bundle-step-prev-next.prev').removeAttr('disabled');

    // On last step: hide Next, show cart buttons
    if (stepIndex === totalSteps) {
      $('.bundle-step-prev-next.next').attr('disabled',true);
      // $('[data-review-bundle]').show();
    } else {
      $('.bundle-step-prev-next.next').removeAttr('disabled');
      // $('.bundle-step-prev-next.next').show();
      // $('[data-review-bundle]').hide();
      controlNextBtn(stepIndex);
    }

    // updateProgressBar(stepIndex);
    // if($(window).width() < 640){
    //   updateProgressItems(stepIndex);
    // }
  }

  function controlNextBtn(stepIndex) {
    var $currentStep = $('.step_inner_main.is-active');
    var $nextBtn = $('.bundle-step-prev-next.next');
    // Step 3 Next always enabled
    // Other steps: Next enabled only if a product is selected
    console.log($currentStep.attr('data-stepitemlimit'),pageaddedcnt)
    if (parseInt($currentStep.attr('data-stepitemlimit')) == parseInt($currentStep.attr('data-addeditemcnt'))) {
      $nextBtn.removeAttr('disabled');
      $('.byob-step_progress-bar--item[step="'+$currentStep.attr('data-step')+'"]').addClass('is-page-selected');
    } else {
      $nextBtn.attr('disabled', true);
      $('.byob-step_progress-bar--item[step="'+$currentStep.attr('data-step')+'"]').removeClass('is-page-selected');
    }
  }

  updateNavButtons(1);
  controlNextBtn(1);

  //BUNDLE PAGE
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  function activecheck(addedcnt,bundle_compare_price,_this){
    if(_this != null){
      console.log(parseInt($(_this).closest('.step_inner_main').attr('data-addeditemcnt')),parseInt($(_this).closest('.step_inner_main').attr('data-stepitemlimit')))
      if(parseInt($(_this).closest('.step_inner_main').attr('data-addeditemcnt')) == parseInt($(_this).closest('.step_inner_main').attr('data-stepitemlimit'))){
        console.log('ifff')
        $(_this).closest('.step_inner_main').find('.bundle-product-item__cta:not(.added),.select_a_size').attr('disabled','disabled');
        $(_this).closest('.step_inner_main').find('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').attr('disabled','disabled');      
        // $('.bundle-step-prev-next.next').removeAttr('disabled');
      }else{
        console.log('elssss')
        $(_this).closest('.step_inner_main').find('.bundle-product-item__cta:not(.added),.select_a_size').removeAttr('disabled');
        $(_this).closest('.step_inner_main').find('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').removeAttr('disabled');      
        // $('.bundle-step-prev-next.next').attr('disabled','disabled');
      }
      if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
        // $('.bundle-product-item__cta:not(.added),.select_a_size').attr('disabled','disabled');
        // $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').attr('disabled','disabled');
        $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add to cart<svg width="18" height="18" class="icon icon--quick-buy-shopping-cart   " viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.592726 0.774894C1.04345 0.713177 2.05356 0.720973 2.51557 0.7645C2.80061 0.791136 3.00192 0.917169 3.12425 1.20302C3.37782 1.79745 3.48293 2.71476 3.76025 3.26827C3.83863 3.42484 3.96215 3.52943 4.12605 3.55022L14.4226 3.55737C14.8288 3.58985 15.1049 4.0537 14.9618 4.47468C14.346 6.23005 13.9475 8.17576 13.3079 9.90904C13.1844 10.2436 13.0585 10.4424 12.6999 10.4781L5.84224 10.4794C5.72288 10.497 5.59401 10.5769 5.53225 10.6925C5.46218 10.8238 5.32679 11.4507 5.35589 11.5904C5.38795 11.7437 5.58332 11.8658 5.7205 11.8736L13.438 11.8762C14.1286 12.0256 14.0942 13.1697 13.3822 13.2392H5.54176C4.83865 13.1573 4.25729 12.5648 4.11595 11.8106C3.96096 10.9823 4.5061 10.2631 4.29589 9.4374L2.17352 2.46984C2.12304 2.32497 1.99596 2.19764 1.85403 2.1697C1.38668 2.0768 0.547594 2.33991 0.196637 1.96896C-0.20539 1.54214 0.0499597 0.848955 0.592726 0.774894Z" fill="currentColor"></path>
          <path d="M4.17296 16.3133C2.9271 14.9504 4.95564 12.9748 6.0483 14.4404C7.07148 15.8131 5.29056 17.536 4.17296 16.3133Z" fill="currentColor"></path>
          <path d="M11.7741 16.3133C10.5282 14.9504 12.5567 12.9748 13.6494 14.4404C14.6726 15.8131 12.8917 17.536 11.7741 16.3133Z" fill="currentColor"></path>
        </svg></span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--primary').removeClass('button--outline');
        $('.bundle-preview_cart-prices').show();
      }else{
        // $('.bundle-product-item__cta:not(.added),.select_a_size').removeAttr('disabled');
        // $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').removeAttr('disabled');
        $('.bundle-add_to_cart_button').html('Add To Box').addClass('button--outline').removeClass('readytoadd button--primary');
        $('.bundle-preview_cart-prices').hide();
      }
      if(parseInt($('.bundle-preview_cart-buttons .data-bundleprice').attr('data-thisprice')) < bundle_compare_price){
        $('.bundle-preview_cart-prices .price--compare').html(window.formatMoney(bundle_compare_price, currencyFormat));  
      }
      
      
      if(addedcnt > 0){
        $('.bundle-preview_cart').show();
      }else{
        $('.bundle-preview_cart').hide();
      }

      updateNavButtons($(_this).closest('.step_inner_main').attr('data-step'))
    }else{
      if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
        $('.bundle-product-item__cta:not(.added),.select_a_size').attr('disabled','disabled');
        $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').attr('disabled','disabled');
        $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add to cart<svg width="18" height="18" class="icon icon--quick-buy-shopping-cart   " viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.592726 0.774894C1.04345 0.713177 2.05356 0.720973 2.51557 0.7645C2.80061 0.791136 3.00192 0.917169 3.12425 1.20302C3.37782 1.79745 3.48293 2.71476 3.76025 3.26827C3.83863 3.42484 3.96215 3.52943 4.12605 3.55022L14.4226 3.55737C14.8288 3.58985 15.1049 4.0537 14.9618 4.47468C14.346 6.23005 13.9475 8.17576 13.3079 9.90904C13.1844 10.2436 13.0585 10.4424 12.6999 10.4781L5.84224 10.4794C5.72288 10.497 5.59401 10.5769 5.53225 10.6925C5.46218 10.8238 5.32679 11.4507 5.35589 11.5904C5.38795 11.7437 5.58332 11.8658 5.7205 11.8736L13.438 11.8762C14.1286 12.0256 14.0942 13.1697 13.3822 13.2392H5.54176C4.83865 13.1573 4.25729 12.5648 4.11595 11.8106C3.96096 10.9823 4.5061 10.2631 4.29589 9.4374L2.17352 2.46984C2.12304 2.32497 1.99596 2.19764 1.85403 2.1697C1.38668 2.0768 0.547594 2.33991 0.196637 1.96896C-0.20539 1.54214 0.0499597 0.848955 0.592726 0.774894Z" fill="currentColor"></path>
          <path d="M4.17296 16.3133C2.9271 14.9504 4.95564 12.9748 6.0483 14.4404C7.07148 15.8131 5.29056 17.536 4.17296 16.3133Z" fill="currentColor"></path>
          <path d="M11.7741 16.3133C10.5282 14.9504 12.5567 12.9748 13.6494 14.4404C14.6726 15.8131 12.8917 17.536 11.7741 16.3133Z" fill="currentColor"></path>
        </svg></span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--primary').removeClass('button--outline');
        $('.bundle-preview_cart-prices').show();
      }else{
        $('.bundle-product-item__cta:not(.added),.select_a_size').removeAttr('disabled');
        $('.bundle-product-item__cta-wrapper .quantity-selector__button.plus').removeAttr('disabled');
        $('.bundle-add_to_cart_button').html('Add To Box').addClass('button--outline').removeClass('readytoadd button--primary');
        $('.bundle-preview_cart-prices').hide();
      }
      if(parseInt($('.bundle-preview_cart-buttons .data-bundleprice').attr('data-thisprice')) < bundle_compare_price){
        $('.bundle-preview_cart-prices .price--compare').html(window.formatMoney(bundle_compare_price, currencyFormat));  
      }
      
      
      if(addedcnt > 0){
        $('.bundle-preview_cart').show();
      }else{
        $('.bundle-preview_cart').hide();
      }
    }
  }

  function qtyatc(totalqty, _this){
    if(totalqty > 0){
      $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').hide();
      $(_this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').removeClass('hidden');
      $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
    }else{
      $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
      $(_this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').addClass('hidden');
      $(_this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--primary').html(`Add to box`);
    }
  }
  var addedcnt = 0;
  
  var bundle_compare_price = 0;
  $('body').on('click', '.bundle-without-step .bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    bundle_compare_price += parseInt($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-compprice'));
    var totalqty = parseInt($(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val()) + 1;
    qtyatc(totalqty, this);
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val(totalqty);
    activecheck(addedcnt,bundle_compare_price);     
    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item-wrapper"><img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></div></div>`; 
    $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    $('.bundle-preview_cart-item.hasblank').first().attr('data-qty', totalqty).attr('data-vid',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-vid')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-price')).removeClass('hasblank');
  });

  $('body').on('click', '.step-product-list .bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    pageaddedcnt += 1;
    var currentStepIndex = $(this).closest('.step_inner_main').attr('data-step');
    $(this).closest('.step_inner_main').attr('data-addeditemcnt',pageaddedcnt);
    $('.byob-step_progress-bar--item[step="'+currentStepIndex+'"]').addClass('is-page-selected');
    bundle_compare_price += parseInt($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-compprice'));
    var totalqty = parseInt($(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val()) + 1;
    qtyatc(totalqty, this);
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector [name="quantity"]').val(totalqty);
    
    activecheck(addedcnt,bundle_compare_price,this);     
    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item-wrapper"><img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></div></div>`; 
    $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    $('.bundle-preview_cart-item.hasblank').first().attr('data-qty', totalqty).attr('data-vid',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-vid')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-price')).removeClass('hasblank');
  });

  // Next button click handling
  $('body').on('click', '.bundle-step-prev-next.next', function() {
    if ($(this).is('[disabled]')) return;
    var $currentStep = $('.step_inner_main.is-active').attr('data-step');
    var nextstep = parseInt($currentStep) + 1;
    // var currentStepIndex = $('.byob-step_item').index($currentStep) + 1;
    var $nextStep = $('.step_inner_main[data-step="'+nextstep+'"]');

    $('.byob-step_progress-bar--item').removeClass('active')
    for(var i = 0;i < $currentStep;i++){
      $('.byob-step_progress-bar--item').eq(i).addClass('active')
    }
    // if($(window).width() < 640){
    //   updateProgressItems(nextstep);
    // }

    if ($nextStep.length) {
      $('.step_inner_main').removeClass('is-active');
      $nextStep.addClass('is-active');
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      pageaddedcnt = 0;
      // $('.byob_slide').removeClass('active');
      // $('.byob_slide[step="'+nextstep+'"]').addClass('active');
      $('.byob-step_progress-bar--item').removeClass('is-page-active');
      $('.byob-step_progress-bar--item[step="'+nextstep+'"]').addClass('is-page-active');
      updateNavButtons(nextstep);
    }
  });

  $('body').on('click', '.bundle-step-prev-next.prev', function() {
    console.log('ihihihih')
    var $currentStep = $('.step_inner_main.is-active').attr('data-step');
    var prevstep = parseInt($currentStep) - 1;
    // var currentStepIndex = $('.byob-step_item').index($currentStep) + 1;
    var $prevStep = $('.step_inner_main[data-step="'+prevstep+'"]');

    $('.byob-step_progress-bar--item').removeClass('active')
    for(var i = 0;i < $currentStep - 1;i++){
      $('.byob-step_progress-bar--item').eq(i - 1).addClass('active')
    }
    // if($(window).width() < 640){
    //   updateProgressItems(prevstep);
    // }

    if ($prevStep.length) {
      $('.step_inner_main').removeClass('is-active');
      // $('.byob-step_item').removeClass('is-active');
      $prevStep.addClass('is-active');
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      pageaddedcnt = 0;
      // $('.byob_slide').removeClass('active');
      // $('.byob_slide[step="'+prevstep+'"]').addClass('active');
      $('.byob-step_progress-bar--item').removeClass('is-page-active');
      $('.byob-step_progress-bar--item[step="'+prevstep+'"]').addClass('is-page-active');
      updateNavButtons(prevstep);
    }
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector__button.plus', function(e){
    addedcnt += 1;
    pageaddedcnt += 1;
    $(this).closest('.step_inner_main').attr('data-addeditemcnt',pageaddedcnt);
    bundle_compare_price += parseInt($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-compprice'));
    var currentqty = parseInt($(this).closest('.quantity-selector').find('[name="quantity"]').val());
    qtyatc(currentqty, this);
    
    // $(this).closest('.quantity-selector').find('[name="quantity"]').val(totalqty);
    activecheck(addedcnt,bundle_compare_price,this);    
    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item-wrapper"><img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></div></div>`; 
    $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    $('.bundle-preview_cart-item.hasblank').first().attr('data-qty', currentqty).attr('data-vid',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-vid')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-price')).removeClass('hasblank');
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector__button.minus', function(e){
    addedcnt = addedcnt - 1;
    pageaddedcnt = pageaddedcnt - 1;
    $(this).closest('.step_inner_main').attr('data-addeditemcnt',pageaddedcnt);
    bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-compare_price'));
    activecheck(addedcnt,bundle_compare_price,this);    
    var currentqty = parseInt($(this).closest('.quantity-selector').find('[name="quantity"]').val());
    qtyatc(currentqty, this);
    
    $(`.bundle-preview_cart-item[data-qty="${currentqty + 1}"][data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');    
    
  });

  // $('body').on('click', '.bundle-product-item__cta-remove', function(e){
  //   e.preventDefault();    
  //   addedcnt = addedcnt - 1;
  //   bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-compare_price'));
  //   activecheck(addedcnt,bundle_compare_price); 
  //   $(this).next().removeAttr("disabled").removeClass('added button--outline').addClass('button--primary').html(`Add to box`);
  //   $(`.bundle-preview_cart-item[data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
  //   $(this).remove();
  // });

  $('body').on('click','.bundle-preview_car-item-remove', function(){
    addedcnt = addedcnt - 1;
    bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price'));
    activecheck(addedcnt,bundle_compare_price); 
    var currentqty = $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('[name="quantity"]').val();
    var tochangeqty = parseInt(currentqty) - 1;
    $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('[name="quantity"]').val(tochangeqty);
    if(tochangeqty == 0){
      $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.quantity-selector').addClass('hidden');
      $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--primary').html(`Add to box`).show();
    }
    // $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.bundle-product-item__cta-remove').remove();    
    $(this).closest('.bundle-preview_cart-item').addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
  });

  $('body').on('click','.bundle-add_to_cart_button.readytoadd ', function(){
    $(this).attr("aria-busy",true);
    var items = [];
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item:not(.hasblank)').each(function(i,v){
      var val = $(this).attr('data-vid');         
       items.push({
        quantity: 1,
        id: val
      });   
    });    
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
      $(this).removeAttr("aria-busy");
    }.bind(this));  
    
  });

  $('body').on('change','.product-variants-selection input[type="radio"]', function(){
    var checkedinput = $(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked');
    if(checkedinput.attr('data-price') < checkedinput.attr('data-compprice')){
      var pricehtml = `<span class="price price--highlight">${window.formatMoney(checkedinput.attr('data-price'),currencyFormat)}</span>
            <span class="price price--compare">${window.formatMoney(checkedinput.attr('data-compprice'), currencyFormat)}</span>`;  
    }else{
      var pricehtml = `<span class="price">${window.formatMoney(checkedinput.attr('data-price'), currencyFormat)}</span>`; 
    }
    $(this).closest('.product-item').find('.price-list').html(pricehtml);
    if($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').length > 0){
     $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .select_a_size').addClass('size_not_selected');
     $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .bundle-product-item__cta').removeClass('size_not_selected'); 
    }else{
     $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .select_a_size').removeClass('size_not_selected');
     $(this).closest('.product-item').find('.bundle-product-item__cta-wrapper .bundle-product-item__cta').addClass('size_not_selected'); 
    }    
  });

  $('body').on('click','.select_a_size', function(){
    var _this = $(this);
    _this.closest('.product-item__info').find('.product-variants-selection').addClass('shake');
    setTimeout(function(){
      _this.closest('.product-item__info').find('.product-variants-selection').removeClass('shake');
    },1000)
  });
  
});
$('body').on('keyup', '.line-item-property-input-input__field', function(e) {
  e.preventDefault();
  var data_value = $(this).attr('data-value');
  var value = $(this).val();
  var button = $(this).parent('.line-item-property-input').find('.line-item-property-input-submit');
  let regex = /^[a-zA-Z_ ]{1,15}$/;

  console.log(value, regex.test(value));
  console.log($(this).val().length);
  if(regex.test(value)){
    $(this).parent('.line-item-property-input').removeClass('error');
    $(this).parent('.line-item-property-input').find('.line-item-property-input-submit').show();
  }else{
    $(this).parent('.line-item-property-input').addClass('error');
    $(this).parent('.line-item-property-input').find('.line-item-property-input-submit').hide();
  }
  if(data_value == value){
    console.log('edit');
    $(button).hide();
    $(button).attr("disabled", "disabled");
  }else{
    console.log('submit');
    $(button).show();
    $(button).removeAttr("disabled", "disabled");
  }
});